export const NII = {
  FindSummaryData: {
    Data: {}
  },
  FindExtremeEventsData: {
    Data: {}
  },
  FindSimulationData: {
    Data: {}
  },
  FindHistoricalData: {
    Data: {}
  },
  FindInternalThresholds: {
    Data: {}
  },
  SelectedPeriod: 'risk12mAnalysisData'
}
